// extracted by mini-css-extract-plugin
export default {"root":"FullScreenLoader_root__aaVSk","loaderContainer":"FullScreenLoader_loaderContainer__H0DOa"};